<script>
	import CmsImage from '$lib/components/cms-image.svelte';
	import Seo from '$lib/components/seo.svelte';
	import { marked } from 'marked';
	import { displayLanguage, humanizeDate } from '$lib/i18n/translation';

	export let data;
	let article = data.article;
</script>

<Seo title={article.Title} description={article.ShortDescription} noindex={article.NoIndex}></Seo>

<div class="container py-20 max-w-6xl">
	{#if article.Teaser && article.Teaser.data !== null}
		<CmsImage cmsData={article.Teaser} cssClass={'w-full block rounded shadow-md mb-16'} />
	{/if}

	<article class="prose lg:prose-xl mx-auto">
		<h1 class="!mb-2">{article.Headline}</h1>
		<p class="!mt-0 text-right">{humanizeDate(new Date(article.publishedAt), $displayLanguage)}</p>

		<p>{article.ShortDescription}</p>

		{@html marked(article.PageContent)}
	</article>
</div>
